import { ErrorBoundary } from '../monitoring/error-boundary';
import { FrDexPage as FrDexPageBase } from './fr-dex-page';

export const FrDexPage = () => {
    return (
        <ErrorBoundary name="FR_DEX_NEW_SEARCH">
            <FrDexPageBase />
        </ErrorBoundary>
    );
};
